module.exports = __webpack_public_path__ + "img/logo.278e8e07.png";